<section class="auth_sc">
  <div class="auth_flx gap_m">
    <div class="auth_lft">
      
        <figure class="logo" routerLink="/auth/login">
          <img src="{{ assetsConst.logo }}" alt="logo" />
        </figure>
      
      <router-outlet />
    </div>
    <mindbase-auth-right class="auth_right" />
  </div>
</section>
